import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CheckItem } from '../CheckItem';
import { solutionCycle, solutionItems } from '../../data/salesContent';
export function SolutionSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" style={{
    backgroundImage: 'radial-gradient(ellipse 60% 45% at 50% 0%, rgba(212,175,55,0.10), transparent 70%)'
  }} data-id="element-179" data-mp="15y2u5i5jjteh">
      <div className="mx-auto max-w-5xl" data-id="element-180" data-mp="dd2zodyurcby">
        <SectionHeading title="Imaginá abrir un único sistema y encontrar todo organizado" data-id="element-181" data-mp="iamebezgpr4f" />
        <ul className="mx-auto mt-12 grid max-w-4xl gap-4 sm:grid-cols-2" data-id="element-182" data-mp="i88mrg3zqx1m">
          {solutionItems.map(item => <CheckItem key={item} className="rounded-xl border border-ink-line bg-ink-soft px-5 py-4 text-lg font-medium text-cream md:text-xl" data-id="element-183" data-mp="r2wncsymfqk3">
              {item}
            </CheckItem>)}
        </ul>
        <p className="mt-14 text-center font-display text-2xl font-black uppercase text-cream md:text-4xl" data-id="element-184" data-mp="3urzyhukj0z6g">
          Eso es <span className="text-gold" data-id="element-185" data-mp="32lfxjih9j23p">Primeros Auxilios para Instructores™</span>
        </p>
        <ol className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-186" data-mp="2xm3c9261i338">
          {solutionCycle.map((step, i) => <li key={step} className="flex items-center gap-3 text-lg font-semibold text-neutral-200 md:text-xl" data-id="element-187" data-mp="2sucz6ofpx184" data-mpi={i}>
              {step}
              {i < solutionCycle.length - 1 && <ArrowRightIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-188" data-mp="2iwyoz6ke18o9" />}
            </li>)}
        </ol>
      </div>
    </section>;
}